import { Component, ChangeDetectionStrategy, input, model, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-material-header',
    standalone: true,
    imports: [FormsModule, NgTemplateOutlet],
    template: `
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 bg-white p-5 rounded-xl shadow-sm border border-gray-100 gap-4">
        <h2 class="font-bold text-gray-800 tracking-tight flex items-center gap-3">
            <span class="w-1.5 h-6 bg-indigo-500 rounded-full"></span>
            {{ title() }}
        </h2>
        <div class="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center w-full md:w-auto">
            @if (showSearch()) {
                <div class="relative flex-1 sm:flex-initial group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500 transition-colors"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
                    <input 
                        type="text" 
                        [placeholder]="searchPlaceholder()" 
                        class="pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 focus:bg-white outline-none transition-all w-full sm:w-64 "
                        [ngModel]="searchTerm()"
                        (ngModelChange)="searchTerm.set($event)"
                    />
                </div>
            }
            @if (actionTemplate()) {
                <ng-container [ngTemplateOutlet]="actionTemplate()"></ng-container>
            }
        </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialHeaderComponent {
    title = input.required<string>();
    showSearch = input<boolean>(false);
    searchPlaceholder = input<string>('Search records...');
    searchTerm = model('');
    actionTemplate = input<TemplateRef<any> | null>(null);
}
